/**
 * SelectionDebugChip - Visual debug indicator for property selection state
 * Only visible when ?debug=1
 */
import { useSession } from '../../contexts/SessionContext.jsx';

export default function SelectionDebugChip() {
  const { selectedListingId, selectedProperty, lastSelectionSource, lastSelectionAt, providerInstanceId } = useSession();
  
  // Only show when ?debug=1
  const debug = typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('debug') === '1';
  if (!debug) return null;
  
  const propertyName = selectedProperty?.name || selectedProperty?.property_name || 'None';
  const propertyListingId = selectedProperty?.listing_id || null;
  
  return (
    <div style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '0.5rem',
      padding: '0.25rem 0.5rem',
      backgroundColor: 'rgba(255, 255, 0, 0.1)',
      border: '1px solid rgba(255, 255, 0, 0.3)',
      borderRadius: '4px',
      fontSize: '0.75rem',
      fontFamily: 'monospace',
      marginLeft: '1rem',
    }}>
      <span style={{ fontWeight: 'bold' }}>SELECT:</span>
      <span>id={selectedListingId ?? 'null'}</span>
      <span>|</span>
      <span>prop.id={propertyListingId ?? 'null'}</span>
      <span>|</span>
      <span>name="{propertyName}"</span>
      <span>|</span>
      <span>src={lastSelectionSource}</span>
      <span>|</span>
      <span>at={lastSelectionAt ? new Date(lastSelectionAt).toLocaleTimeString() : 'never'}</span>
      <span>|</span>
      <span>inst={providerInstanceId}</span>
    </div>
  );
}